import axios from 'axios';
import { requestFailed } from '../InvoicingCycle/invoicingCycleApi';

const STATUS_MAPPINGS = '/import-status-mappings';
const UNPROCESSABLE = 422;

// The app's axios interceptor resolves 4xx responses instead of rejecting them, so each call
// reads the status off the resolved response.
export const fetchStatusMappings = async () => {
  const response = await axios.get(STATUS_MAPPINGS);

  if (requestFailed(response)) {
    return { errors: `The status mappings could not be loaded (status ${response?.status}).` };
  }

  return response.data;
};

export const saveStatusMappings = async mappings => {
  const response = await axios.put(STATUS_MAPPINGS, { mappings });

  if (response?.status === UNPROCESSABLE) {
    return { fieldErrors: response.data.errors };
  }
  if (requestFailed(response)) {
    return { errors: `The status mappings could not be saved (status ${response?.status}).` };
  }

  return response.data;
};
